import { Link } from "react-router-dom";
import { cn } from "@/lib/utils";
import type { PricingTier } from "@/data/automacaoServices";

interface PricingTiersProps {
  tiers: PricingTier[];
}

const PricingTiers = ({ tiers }: PricingTiersProps) => (
  <div className="grid grid-cols-[repeat(auto-fit,minmax(270px,1fr))] items-start gap-[18px]">
    {tiers.map((tier) => (
      <div
        key={tier.name}
        className={cn(
          "relative rounded-[18px] p-7 shadow-card",
          tier.highlight
            ? "border-[1.5px] border-primary bg-accent"
            : "border border-border bg-background",
        )}
      >
        <div
          className={cn(
            "text-[11px] font-bold uppercase tracking-[.06em]",
            tier.highlight ? "text-primary" : "text-muted-foreground",
          )}
        >
          {tier.badge}
        </div>
        <h3 className="mt-3 text-[17px] font-bold tracking-[-0.01em]">{tier.name}</h3>
        <div className="mt-3.5 text-[23px] font-bold tracking-[-0.03em]">{tier.priceRange}</div>
        <div className="mt-1 text-xs text-muted-foreground">{tier.paymentNote}</div>
        <div className="mt-5 flex flex-col gap-2.5">
          {tier.includes.map((item) => (
            <div key={item} className="flex items-start gap-2.5">
              <span className="mt-px text-xs font-bold text-primary">✓</span>
              <span className="text-[13px] leading-[1.5] text-muted-foreground">{item}</span>
            </div>
          ))}
        </div>
        <div className="mt-5 border-t border-border/70 pt-4 text-[12.5px] leading-[1.55] text-muted-foreground">
          {tier.indicatedFor}
        </div>
        <Link
          to="/contato"
          className={cn(
            "mt-5 flex h-[42px] w-full items-center justify-center rounded-[11px] text-[13px] font-bold transition-[filter] hover:brightness-95",
            tier.highlight
              ? "bg-primary text-primary-foreground"
              : "border border-border bg-transparent text-foreground",
          )}
        >
          {tier.cta}
        </Link>
      </div>
    ))}
  </div>
);

export default PricingTiers;
